import Component, { mixins } from 'vue-class-component';
import VueCqrs from '@cqrs/vue-component-cqrs';
import PageBase from '@common/PageBase';
import * as c from './commands-core';

@Component
export default class VuePageCommands extends mixins(PageBase, VueCqrs) {
	invokeApplyBrandingCommandV1(id: string, logoBlobId: string)
	{
		const cmd = new c.ApplyBrandingCommandV1(id, logoBlobId);
		this.$command(cmd);
	}

	invokeConfigureOauth2CommandV1(id: string, clientId: string, clientSecret: string, tokenEndpointUri: string, authorizationEndpointUri: string)
	{
		const cmd = new c.ConfigureOauth2CommandV1(id, clientId, clientSecret, tokenEndpointUri, authorizationEndpointUri);
		this.$command(cmd);
	}

	invokeCreateOrganizationUnitCommandV1(id: string, name: string, description: string)
	{
		const cmd = new c.CreateOrganizationUnitCommandV1(id, name, description);
		this.$command(cmd);
	}

	invokeResetBrandingCommandV1(id: string)
	{
		const cmd = new c.ResetBrandingCommandV1(id);
		this.$command(cmd);
	}

	invokeUpdateOrganizationUnitCommandV1(id: string, name: string, description: string)
	{
		const cmd = new c.UpdateOrganizationUnitCommandV1(id, name, description);
		this.$command(cmd);
	}

	succeedAnyCommand(status: any) { }
	invalidAnyCommand(status: any) { }
	failedAnyCommand(status: any) { }

	onSetCommandStatus(status: any) {
		status.Success ? 
			this.succeedAnyCommand(status) :
			status.ValidationErrors ?
				this.invalidAnyCommand(status) :
				this.failedAnyCommand(status);

		if (c.ApplyBrandingCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedApplyBrandingCommandV1(status) :
				status.ValidationErrors ?
					this.invalidApplyBrandingCommandV1(status) :
					this.failedApplyBrandingCommandV1(status);
			return;
		}

		if (c.ConfigureOauth2CommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedConfigureOauth2CommandV1(status) :
				status.ValidationErrors ?
					this.invalidConfigureOauth2CommandV1(status) :
					this.failedConfigureOauth2CommandV1(status);
			return;
		}

		if (c.CreateOrganizationUnitCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedCreateOrganizationUnitCommandV1(status) :
				status.ValidationErrors ?
					this.invalidCreateOrganizationUnitCommandV1(status) :
					this.failedCreateOrganizationUnitCommandV1(status);
			return;
		}

		if (c.ResetBrandingCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedResetBrandingCommandV1(status) :
				status.ValidationErrors ?
					this.invalidResetBrandingCommandV1(status) :
					this.failedResetBrandingCommandV1(status);
			return;
		}

		if (c.UpdateOrganizationUnitCommandV1.matchType(status.Command)) {
			status.Success ? 
				this.succeedUpdateOrganizationUnitCommandV1(status) :
				status.ValidationErrors ?
					this.invalidUpdateOrganizationUnitCommandV1(status) :
					this.failedUpdateOrganizationUnitCommandV1(status);
			return;
		}

	}

	succeedApplyBrandingCommandV1(status: any) { }
	invalidApplyBrandingCommandV1(status: any) { }
	failedApplyBrandingCommandV1(status: any) { }

	succeedConfigureOauth2CommandV1(status: any) { }
	invalidConfigureOauth2CommandV1(status: any) { }
	failedConfigureOauth2CommandV1(status: any) { }

	succeedCreateOrganizationUnitCommandV1(status: any) { }
	invalidCreateOrganizationUnitCommandV1(status: any) { }
	failedCreateOrganizationUnitCommandV1(status: any) { }

	succeedResetBrandingCommandV1(status: any) { }
	invalidResetBrandingCommandV1(status: any) { }
	failedResetBrandingCommandV1(status: any) { }

	succeedUpdateOrganizationUnitCommandV1(status: any) { }
	invalidUpdateOrganizationUnitCommandV1(status: any) { }
	failedUpdateOrganizationUnitCommandV1(status: any) { }

}
